import { useQuery } from '@tanstack/react-query';
import { PropTypes } from 'prop-types';
import { getTrustBeneficiaryAnalysis } from 'react/member/components/dashboard/clients/dashboard_client/overview/api';

export default function useTrustBeneficiaryAnalysisQuery({ clientSlug }) {
  const result = useQuery({
    queryKey: ['trustBeneficiaryAnalysis', clientSlug],
    queryFn: ({ queryKey }) =>
      getTrustBeneficiaryAnalysis(queryKey[1], [
        'canHaveDisbursementRequested',
        'canHaveCashRaiseRequested',
        'canAddCardForBene',
        'investmentSum',
        'availableCashSum',
        'uniqueAssetsSum',
        'approvedDisbursementsSum',
        'processedDisbursementsSum',
        'effectiveBalance',
        'currentBalance',
      ]),
    enabled: !!clientSlug,
    staleTime: 60 * 1000,
  });

  return { ...result };
}

useTrustBeneficiaryAnalysisQuery.propTypes = {
  clientSlug: PropTypes.string.isRequired,
};
